import { projects, companyInfo } from '../mockData';

export const SITE_URL = 'https://luxdall.pt';
export const SITE_NAME = 'LuxDall';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
export const PROJECTS_VISIBLE = false;

export const DEFAULT_SEO = {
  title: `${SITE_NAME} | Iluminação Profissional e Gestão de Projetos`,
  description:
    'Soluções de iluminação LED para hospitais, escolas, centros culturais e grandes obras. Consultoria, fornecimento e gestão de projeto em Portugal.',
};

export const ROUTE_SEO = {
  '/': {
    title: `${SITE_NAME} | Projetos de Iluminação`,
    description:
      'Transformamos espaços com iluminação inovadora e eficiente. Especialistas em grandes obras, retrofit LED e gestão de projetos desde 2009.',
  },
  '/projetos': {
    title: `Projetos de Iluminação | ${SITE_NAME}`,
    description:
      'Portfólio de projetos de iluminação em hospitais, escolas, universidades e centros culturais por todo Portugal.',
    noindex: true,
  },
  '/catalogos': {
    title: `Catálogos de Iluminação | ${SITE_NAME}`,
    description:
      'Explore catálogos de marcas líderes em iluminação profissional. Produtos LED, sistemas DALI e soluções para grandes obras.',
  },
  '/sobre': {
    title: `Sobre Nós | ${SITE_NAME}`,
    description:
      'Conheça a LuxDall — empresa especializada em gestão de projetos de iluminação para grandes obras em Portugal.',
  },
  '/contactos': {
    title: `Contactos | ${SITE_NAME}`,
    description:
      'Entre em contacto com a LuxDall. Morada em Águeda, telefone +351 234 136 136. Pedidos de orçamento e projetos de iluminação.',
  },
  '/termos': {
    title: `Termos de Serviço | ${SITE_NAME}`,
    description: 'Termos e condições de utilização do website LuxDall.',
    noindex: true,
  },
  '/privacidade': {
    title: `Política de Privacidade | ${SITE_NAME}`,
    description: 'Política de privacidade e proteção de dados da LuxDall.',
    noindex: true,
  },
  '/single': {
    title: 'Preview',
    description: 'Preview page',
    noindex: true,
  },
};

export function getCanonicalUrl(pathname) {
  const path = pathname === '/' ? '' : pathname;
  return `${SITE_URL}${path}`;
}

export function isProjectsPath(pathname) {
  return pathname === '/projetos' || /^\/projetos\/\d+$/.test(pathname);
}

export function getSeoForPath(pathname) {
  const projectMatch = pathname.match(/^\/projetos\/(\d+)$/);
  if (projectMatch) {
    const project = projects.find((p) => p.id === parseInt(projectMatch[1], 10));
    if (project) {
      return {
        title: `${project.title} | Projetos ${SITE_NAME}`,
        description: project.description,
        image: project.image?.startsWith('http') ? project.image : DEFAULT_OG_IMAGE,
        noindex: !PROJECTS_VISIBLE,
      };
    }
  }

  const routeSeo = ROUTE_SEO[pathname] ?? DEFAULT_SEO;
  if (!PROJECTS_VISIBLE && isProjectsPath(pathname)) {
    return { ...routeSeo, noindex: true };
  }

  return routeSeo;
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: companyInfo.name,
    legalName: companyInfo.legalName,
    description: companyInfo.description,
    url: SITE_URL,
    email: companyInfo.email,
    telephone: companyInfo.phone,
    image: DEFAULT_OG_IMAGE,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'R. Celestino Neto 17 1ºA',
      addressLocality: 'Águeda',
      postalCode: '3750-101',
      addressCountry: 'PT',
    },
    areaServed: {
      '@type': 'Country',
      name: 'Portugal',
    },
  };
}

export function getProjectSchema(project) {
  return {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    name: project.title,
    description: project.description,
    url: `${SITE_URL}/projetos/${project.id}`,
    image: project.image,
    dateCreated: project.year,
    locationCreated: project.location,
    creator: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
    },
  };
}
